<template>
  <div class="dev-list">
    <div class="dev-list-search">
      <div class="search-btn">
        <el-button
          size="small"
          type="primary"
          @click="allDelete"
          v-if="$store.getters.checkChangeAuth()"
          >全部删除</el-button
        >
        <el-button
          size="small"
          type="primary"
          :disabled="multipleSelection.length === 0"
          @click="deleteDevBatch"
          v-if="$store.getters.checkChangeAuth()"
          >删除</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="advancedShow = !advancedShow"
          >高级筛选</el-button
        >
      </div>
      <div class="search-advanced" v-show="advancedShow">
        <div class="search-main">
          <div class="search-main-item">
            <span>分发类别:</span>
            <div class="item-input">
              <el-select
                v-model="searchInfo.issuedMode"
                size="mini"
                placeholder="类别"
              >
                <el-option
                  v-for="item in searchOptions.mode"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="search-main-item">
            <span>分发状态:</span>
            <div class="item-input">
              <el-select
                v-model="searchInfo.issuedStatus"
                size="mini"
                placeholder="状态"
              >
                <el-option
                  v-for="item in searchOptions.status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="search-main-item">
            <span>设备IP:</span>
            <div class="item-input">
              <el-input v-model="searchInfo.deviceIp" size="mini"></el-input>
            </div>
          </div>
          <div class="search-main-item" v-if="$store.state.needLayer">
            <span>分层处理器IP:</span>
            <div class="item-input">
              <el-input v-model="searchInfo.nodeIp" size="mini"></el-input>
            </div>
          </div>
          <div class="search-main-item">
            <span>APPID:</span>
            <div class="item-input">
              <el-input v-model="searchInfo.appId" size="mini"></el-input>
            </div>
          </div>
          <div class="search-main-item"></div>
        </div>
        <div class="search-btn">
          <el-button type="primary" size="mini" @click="getAppMonitorList"
            >搜索</el-button
          >
          <el-button size="mini" @click="advancedShow = false">取消</el-button>
        </div>
      </div>
    </div>
    <div class="device-case-dev border-all">
      <el-table
        ref="multipleTable"
        :height="tableHeight"
        :data="info.list"
        :header-cell-style="{ backgroundColor: '#efefef' }"
        size="mini"
        @row-click="checkRow"
        tooltip-effect="dark"
        style="width: 99%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column label="分发类别">
          <template slot-scope="scope">
            <span>{{ scope.row | modeStr }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="appId" label="APPID"></el-table-column>
        <el-table-column prop="deviceIp" label="设备IP"></el-table-column>
        <el-table-column
          prop="nodeIp"
          label="分层处理器IP"
          v-if="$store.state.needLayer"
        ></el-table-column>
        <el-table-column prop="updateTime" label="时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime | formatDateTime }}
          </template>
        </el-table-column>
        <el-table-column label="分发状态">
          <template slot-scope="scope">
            <span :style="scope.row">
              {{ scope.row | statusStr }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="appSticky(scope.row)"
              v-if="
                $store.getters.checkChangeAuth() &&
                scope.row.issuedStatus == 1 &&
                scope.$index != 0
              "
              >置顶
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="list-bottom">
        <div class="list-bottom-btn"></div>
        <el-pagination
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="page.startPage"
          :page-sizes="[10, 20, 50]"
          :page-size="page.limit"
          :pager-count="5"
          layout="total, sizes, prev, pager, next"
          :total="info.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { commonData } from "@/mixin.js";
export default {
  name: "AppMonitor",
  data() {
    return {
      groupDevPopShow: false, // 是否显示分组弹窗
      formLabelWidth: "120px",
      groupInfo: {
        groupId: "",
        deviceIp: "",
      },
      options: [],
      caseOptions: [],
      addDevicePopShow: false, // 显示手动添加弹窗
      addDevInfo: {
        caseId: "",
        deviceIp: "",
      },
      advancedShow: false,
      searchInfo: {
        issuedMode: "",
        issuedStatus: "",
        deviceIp: "",
        nodeIp: "",
        appId: "",
      },
      searchOptions: {
        status: [
          {
            label: "卸载中",
            value: -1,
          },
          {
            label: "设备等待下载",
            value: 1,
          },
          {
            label: "应用准备中",
            value: 2,
          },
          {
            label: "应用准备完成",
            value: 3,
          },
          {
            label: "设备下载中",
            value: 4,
          },
        ],
        mode: [
          {
            label: "安装",
            value: 1,
          },
          {
            label: "卸载",
            value: -1,
          },
        ],
        version: [],
      },
      timeoutId: 0,
    };
  },
  mixins: [commonData],
  methods: {
    appSticky(appItem) {
      // console.log("appItem " + JSON.stringify(appItem))
      this.$post(this.$uri.apk.apkSticky, { id: appItem.id }).then((res) => {
        if (res.success) {
          this.$message.success("操作成功");
          this.getAppMonitorList();
        }
      });
    },
    /* 表单击行事件 */
    checkRow(r, c, e) {
      if (r.cardType === 1) this.$refs.multipleTable.toggleRowSelection(r);
    },
    /* 获取应用监控列表 */
    getAppMonitorList() {
      this.$post(this.$uri.apk.apkMonitor, {
        ...this.page,
        ...this.searchInfo,
      }).then((res) => {
        // console.log("res " + JSON.stringify(res))
        if (res.success) {
          this.info = res;
        }
      });
    },
    /* 当前页改变 */
    currentChangeHandle(val) {
      this.page.startPage = val;
      this.getAppMonitorList();
    },
    /* 每页条数改变 */
    sizeChangeHandle(val) {
      this.page.limit = val;
      this.getAppMonitorList();
    },
    /* 获取选中的数据 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection)
    },
    /* 批量删除记录 */
    deleteDevBatch() {
      this.$confirm("确认批量删除记录？", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirm-btn-blue",
        iconClass: "el-icon-c-blue",
        cancelButtonText: "取消",
      })
        .then(() => {
          let ids = [];
          this.multipleSelection.forEach((v) => {
            ids.push(v.id);
          });

          this.$post(this.$uri.apk.apkMonitorDelete, { ids }).then(() => {
            this.$message.success("删除完成");
            this.getAppMonitorList();
          });
        })
        .catch(() => {});
    },
    /* 删除全部记录 */
    allDelete() {
      this.$confirm("确认删除全部记录？", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirm-btn-blue",
        iconClass: "el-icon-c-blue",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$post(this.$uri.apk.apkMonitorDeleteAll, {}).then(() => {
            this.$message.success("删除完成");
            this.getAppMonitorList();
          });
        })
        .catch(() => {});
    },
    getSysIsNode() {
      this.$post(this.$uri.system.paramGet, { paramName: "isNode" }).then(
        (res) => {
          if (res.success) {
            // console.log("getSysIsNode res is " + JSON.stringify(res))
            if (res.data.paramValue == 1) {
              // console.log("set NEED_LAYER true")
              this.$store.commit(this.$mutation.IS_NEED_LAYER, true);
            } else {
              // console.log("set NEED_LAYER false")
              this.$store.commit(this.$mutation.IS_NEED_LAYER, false);
            }
          }
        }
      );
    },
  },
  filters: {
    statusStr(row) {
      switch (row.issuedStatus) {
        case -1:
          return "卸载中";
        case 1:
          return "设备等待下载";
        case 2:
          return "应用准备中";
        case 3:
          return "应用准备完成";
        case 4:
          return "设备下载中";
        default:
          return "未知";
      }
    },
    modeStr(row) {
      switch (row.issuedMode) {
        case -1:
          return "应用卸载";
        case 1:
          return "应用安装";
        default:
          return "未知";
      }
    },
  },
  mounted() {
    this.getSysIsNode();
    this.getAppMonitorList();
    this.$nextTick().then(() => {
      if (this.$refs.multipleTable) {
        this.tableHeight =
          window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
      }
    });
  },
};
</script>

<style lang="less" scoped>
.dev-list {
  .dev-list-search {
    width: 100%;
    display: flex;
    flex-direction: column;
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
    .search-advanced {
      display: flex;
      flex-direction: column;
      border: 1px solid #efefef;
      .search-main {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        .search-main-item {
          width: 24%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          /*flex-grow: 1;*/
          padding: 5px 10px;
          span {
            font-size: 12px;
          }
          .item-input {
            width: 180px;
          }
        }
      }
      .search-btn {
        padding: 0 10px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
  .device-case-dev {
    margin-top: 10px;
    .list-bottom {
      padding: 10px 8px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .list-bottom-btn {
        display: flex;
        flex-direction: row;
      }
    }
  }
}
</style>
